import React, { useState, useEffect, useRef } from "react";
import "./Games.css"; // You can style as needed

// Utility: Hide alternate characters for hint (or customize)

const Games = () => {
  const [wordList, setWordList] = useState([]);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [inputValues, setInputValues] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const inputRefs = useRef([]);
  const [rawWordData, setWords] = useState([]);

  useEffect(() => {
    fetch(
      "https://s3napi-dev.s3nsoftware.com/api/Quizzes/DetailedQuizz?id=2293"
    )
      .then((res) => res.json())
      .then((data) => {
        setWords(data);
        // setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
        // setLoading(false);
      });
  }, []);

  const generateHint = (word) => {
    const chars = word.split("");
    const numBlanks = Math.min(2, Math.max(1, Math.floor(Math.random() * 3))); // 1 or 2 blanks

    const indices = [...Array(word.length).keys()];
    const blankIndices = [];

    while (blankIndices.length < numBlanks) {
      const randomIndex = indices.splice(
        Math.floor(Math.random() * indices.length),
        1
      )[0];
      blankIndices.push(randomIndex);
    }

    return chars
      .map((ch, idx) => (blankIndices.includes(idx) ? "_" : ch))
      .join("");
  };

  // Transform word list
  const transformWords = (data) =>
    data.map((item) => ({
      word: item.Word,
      hint: generateHint(item.Word),
      image: item.ImageUrl || "",
      audio: item.Audio || "",
      definition: item.defn || "",
    }));

  // Load and transform words on mount
  useEffect(() => {
    if (rawWordData.length > 0) {
      const preparedWords = transformWords(rawWordData);
      setWordList(preparedWords);
    }
  }, [rawWordData]);

  // Setup input for current word
  useEffect(() => {
    if (wordList.length === 0) return;

    const currentHint = wordList[currentWordIndex].hint;
    const blanks = currentHint.split("").filter((char) => char === "_");
    setInputValues(blanks.map(() => ""));
    inputRefs.current = blanks.map(
      (_, i) => inputRefs.current[i] || React.createRef()
    );
  }, [currentWordIndex, wordList]);

  const handleInputChange = (index, value) => {
    if (!/^[a-zA-Z]?$/.test(value)) return; // Allow only one letter
    const newInputValues = [...inputValues];
    newInputValues[index] = value.toLowerCase();
    setInputValues(newInputValues);

    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].current.focus();
    }
  };

  const handleSubmit = () => {
    const currentWord = wordList[currentWordIndex].word;
    const expectedLetters = currentWord
      .split("")
      .filter((_, i) => wordList[currentWordIndex].hint[i] === "_");
    const isCorrect =
      expectedLetters.join("") === inputValues.join("").toLowerCase();
    setShowResult(true);

    setTimeout(() => {
      setShowResult(false);
      if (isCorrect && currentWordIndex < wordList.length - 1) {
        setCurrentWordIndex(currentWordIndex + 1);
      }
    }, 2000);
  };

  if (!rawWordData.length)
    return <div>No words available. Please try again later.</div>;

  const currentWordObj = wordList[currentWordIndex];
  if (!currentWordObj) return <div>Loading game...</div>;

  const { word, hint, image, audio, definition } = currentWordObj;

  // let inputIndex = 0;

  return (
    <div className="game-wrapper">
      {Array.from({ length: 50 }).map((_, i) => (
        <span
          key={i}
          className="letter"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            fontSize: `${Math.random() * 2 + 1}rem`,
          }}
        >
          {String.fromCharCode(65 + Math.floor(Math.random() * 26))}
        </span>
      ))}

      <div className="game-container">
        <h2>Guess the Word!</h2>
        <p className="definition">Hint: {definition}</p>
        {image && <img src={image} alt="Hint" className="game-image" />}
        {audio && (
          <div>
            <audio controls>
              <source src={audio} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </div>
        )}
        <div className="word-inputs">
          {(() => {
            let blankCounter = 0;
            return hint.split("").map((char, i) => {
              if (char === "_") {
                const inputRef = inputRefs.current[blankCounter];
                const value = inputValues[blankCounter] || "";
                const currentIndex = blankCounter;
                blankCounter++;
                return (
                  <input
                    key={i}
                    ref={inputRef}
                    type="text"
                    maxLength={1}
                    value={value}
                    onChange={(e) =>
                      handleInputChange(currentIndex, e.target.value)
                    }
                    className="letter-input"
                  />
                );
              } else {
                return (
                  <span key={i} className="letter-fixed">
                    {char}
                  </span>
                );
              }
            });
          })()}
        </div>
        <button onClick={handleSubmit} className="submit-button">
          Submit
        </button>
        {showResult && (
          <p
            className={`result-message ${
              inputValues.join("").toLowerCase() ===
              word
                .split("")
                .filter((_, i) => hint[i] === "_")
                .join("")
                ? "correct"
                : "wrong"
            }`}
          >
            {inputValues.join("").toLowerCase() ===
            word
              .split("")
              .filter((_, i) => hint[i] === "_")
              .join("")
              ? "Correct!"
              : "Try Again!"}
          </p>
        )}
      </div>
    </div>
  );
};

export default Games;
